module.exports = __webpack_public_path__ + "img/icon-payment-creditcard.8cb4b594.png";